<template>
  <div class="container-fluid">
    <tab></tab>
    <neck ref="neck"></neck>
    
    <div class="hidden-xs hidden-sm">
      <div class="web-map-center">
        <div class="web-map-fonts columnCenter">
          <div class="web-fonts-title">{{type==1?'蔬适认证地图':'Fitness certification map'}}</div>
          <div class="web-fonts-font">{{type==1?'2021年5月，蔬适周一陆续开始为认同并实践':'In May 2021, we began to recognize and practice it one after another'}}</div>
          <div class="web-fonts-font">{{type==1?'“蔬适周一”理念的餐厅进行认证。':'The restaurant with the concept of "vegetable suitable for Monday" is certified'}}</div>
          <div class="web-fonts-font">{{type==1?'认证餐厅名单持续更新中......期待你的加入':'The list of certified restaurants is constantly updated I look forward to your joining'}}</div>
        </div>
        <div class="web-map-view" id="container"></div>
      </div>

    </div>


    <div class="hidden-md hidden-lg">
      <div class="web-map-center phone-map-center">
        <div class="web-map-fonts phone-fonts columnCenter">
          <div class="web-fonts-title phone-title">{{type==1?'蔬适认证地图':'Fitness certification map'}}</div>
          <div class="web-fonts-font phone-font">{{type==1?'2021年5月，蔬适周一陆续开始为认同并实践':'In May 2021, we began to recognize and practice it one after another'}}</div>
          <div class="web-fonts-font phone-font">{{type==1?'“蔬适周一”理念的餐厅进行认证。':'The restaurant with the concept of "vegetable suitable for Monday" is certified'}}</div>
          <div class="web-fonts-font phone-font">{{type==1?'认证餐厅名单持续更新中......期待你的加入':'The list of certified restaurants is constantly updated I look forward to your joining'}}</div>
        </div>
        <div class="web-map-view phone-map-view" id="phoneContainer"></div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab.vue'
import neck from '@/components/neck.vue'
import footerBar from '@/components/footerBar.vue'
import '@/utils/china.js';
import mapLabel from '@/images/mapLabel.png'
import label2 from '@/images/label2.png'
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar,
    neck:neck
  },
  data () {
    return {
      type:1,
      mapList:[
        {
          lng:'100.297424',
          lat:'25.607153',
          name:'大理',
          province:'云南省',
          highlight:'#f5f8ef',
          infoList:[
            {name:'晓楼'},
            {name:'大理布馋素食馆'},
            {name:'大理夏尔小院'}
          ]
        },
        {
          lng:'113.266785',
          lat:'23.151658',
          name:'广州',
          province:'广东省',
          highlight:'#f5f8ef',
          infoList:[
            {name:'iDAMA'}
          ]
        }
      ],
      showLayer:''
    }
  },
  methods:{
    initMap(name){
      const vm=this
      var SOC = 'CHN'
      var colors = {};
      var colorStr = ''
      var position = null;
      if(name=='phoneContainer'){
        position = new AMap.LngLat(104.892571,43.136359);
      }else{
        position = new AMap.LngLat(107.918421,37.579992);
      }
      
      var getColorByDGP = function(adcode){
        var gdp = 'rgb(255,255,255)'
        return gdp
      }
      var disCountry = new AMap.DistrictLayer.Country({
          zIndex:10,
          SOC:'CHN',
          depth:1,
          styles:{
            'nation-stroke':'#a2b57e',
            'coastline-stroke':'#a2b57e',
            'province-stroke':'#a2b57e',
            'fill':function(props){
              // vm.mapList.forEach(da=>{
              //   if(da.province == props.NAME_CHN){
              //     colorStr = da.highlight
              //   }else{
              //     colorStr = '#f5f8ef'
              //   }
              // })
              let res = vm.mapList.find(item=>item.province == props.NAME_CHN)
              return res&&res.highlight ? res.highlight : '#f5f8ef'
              
            }
          }
      })
      var map = new AMap.Map(name,{
        zooms: [2, 10],
        center:position,
        zoom: name=='phoneContainer'?3.2:5,
        isHotspot:false,
        defaultCursor:'pointer',
        layers:[
            disCountry
        ],
        viewMode:'2D',
        dragEnable:false,
        resizeEnable: false,
        zoomEnable:false,
        doubleClickZoom:false,
        keyboardEnable:false
      })
      vm.mapList.forEach((da,index)=>{
        vm.addMark(new AMap.LngLat(da.lng,da.lat),map,index+1,da.name,da.infoList)
      })
    },
    addMark(position,map,num,city,data){
      const vm=this
      let str = `
        <div class="web-map-img">
          <img src="${mapLabel}" alt="#" class="web-img-real"/>
          <div class="web-img-center columnCenter">
            <div class="img-center-font">${num}</div>
            <div class="img-center-label">${city}</div>
          </div>
        </div>
      `
      var marker = new AMap.Marker({
          position: position,
          content: str,
          extData:{
            name:city,
            data:data
          },
          offset: new AMap.Pixel(-50, -120)
      });
      map.add(marker);
      var infoWindow = null
      marker.on('click', function(evn,data){
        if(infoWindow&&vm.showLayer){
          infoWindow.close()
        }
        if(evn.target.De.extData.name == vm.showLayer){
          vm.showLayer = ''
          return
        }
        console.log(evn.target.De.extData.name)
        infoWindow = new AMap.InfoWindow({
          content: vm.infoWindow(evn.target.De.extData),
          offset: new AMap.Pixel(-140, 60)
        });
        infoWindow.open(map, evn.target.getPosition());
        vm.showLayer = evn.target.De.extData.name
      });
      
    },
    infoWindow(obj){
      const vm=this
      let list = ''
      obj.data.forEach(da=>{
        list+=`<div class="info-window-list">
              <img src="${label2}" alt="#" class="window-list-icon"/>
              <div class="window-list-font">${da.name}</div>
            </div>`
      })
      let str = `
        <div class="web-info-window">
          <div class="info-window-top">${obj.name}</div>
          <div class="info-window-center">
            ${list}
          </div>
        </div>
      `
      return str
    },
    choiceType(num){
      const vm=this
      vm.type = localStorage.getItem('ssType') || Number(num)
      vm.$refs.neck.setType(vm.type,6)
      vm.$refs.neck.setPageTips({
        site_name:'蔬适周一',
        site_name_en:'Meatless Monday',
      })
      vm.$refs.footerView.setType(vm.type)
    }
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.choiceType(1)
    setTimeout(()=>{
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        vm.initMap('phoneContainer')
      }else{
        vm.initMap('container')
      }
    },400)
  }
}
</script>
<style scoped>
/**  首页banner web  **/
.container-fluid {
  width: 100%;
  padding: 0;
  margin: 0;
}
.web-map-view {
  width: 100%;
  height: 6.6rem;
}

/**  首页banner phone  **/

.web-map-center {
  padding: 0.75rem 0 0.625rem;
  height: auto;
  background: #f5f8ef;
  position: relative;
}
.web-map-fonts{
  position: absolute;
  top: 0.8rem;
  left: 0;
  right: 0;
  z-index: 99;
}
.web-fonts-title{
  font-size: 0.3rem;
  color: #365b3a;
  font-weight: 600;
  margin-bottom: 0.15rem;
  line-height: 1;
}
.web-fonts-font{
  font-size: 0.125rem;
  color: #5a625a;
  line-height: 1;
  margin-bottom: 0.08rem;
}


.phone-fonts{
  top: 1.4rem;
}
.phone-title{
  font-size: 0.56rem;
  margin-bottom: 0.32rem;
}
.phone-font{
  font-size: 0.32rem;
  margin-bottom: 0.28rem;
}


.web-map-center /deep/ .web-map-img{
  width: 60px;
  height: 70px;
  position: relative;
}
.web-map-center /deep/ .web-img-real{
  width: 60px;
  height: 70px;
}
.web-map-center /deep/ .web-img-center{
  width: 60px;
  height: 70px;
  position: absolute;
  top: 13px;
  left: 42px;
}
.web-map-center /deep/ .img-center-font{
  font-size: 0.125rem;
  color: #fff;
  font-weight: 600;
  font-family: "Times New Roman", Times, serif;
}
.web-map-center /deep/ .img-center-label{
  font-size: 0.075rem;
  color: #fff;
  font-family: "Times New Roman", Times, serif;
}
.web-map-center /deep/ .amap-logo,.web-map-center /deep/ .amap-copyright,.web-map-center /deep/ .amap-info-sharp,.web-map-center /deep/ .amap-info-close{
  display: none !important;
}

.web-map-center /deep/ .web-info-window{
  min-width: 120px;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.web-map-center /deep/ .info-window-top{
  padding: 0 20px;
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  height: 48px;
  background: rgba(146, 152, 67, 0.95);
  text-align: left;
  line-height: 48px;
  border-radius: 8px 8px 0 0;
  font-family: "Times New Roman", Times, serif;
}
.web-map-center /deep/ .info-window-center{
  padding: 20px 30px 0;
  width: auto;
  height: auto;
}
.web-map-center /deep/ .info-window-list{
  width: auto;
  height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 32px;
}
.web-map-center /deep/ .window-list-icon{
  width: 20px;
  height: auto;
  margin-right: 20px;
}
.web-map-center /deep/ .window-list-font{
  padding: 0 4px;
  height: 20px;
  font-size: 20px;
  color: #000;
  line-height: 20px;
  border-bottom: 1px solid #333;
  font-family: "Times New Roman", Times, serif;
}
.web-map-center /deep/ .amap-info-content{
  padding: 0;
  border-radius: 8px;
}

.phone-map-center {
  padding: 1rem 0 0.6rem;
  height: auto;
  background: #f5f8ef;
}

.phone-map-view{
  height: 9.8rem;
  width: 100%;
}

.phone-center-list{
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  font-size: 0.36rem;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  background: rgba(220,155,97,0.95);
  position: relative;
}
.bottom-list-icon{
  display: block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid rgba(146,152,67,0.95);
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

</style>

